import { render, staticRenderFns } from "./selectmissingword.vue?vue&type=template&id=c20e7c86&scoped=true&"
import script from "./selectmissingword.vue?vue&type=script&lang=js&"
export * from "./selectmissingword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20e7c86",
  null
  
)

export default component.exports